import LayoutTypes from '../enums/layout/layoutTypes';

const isDesktopLayout = (layout: LayoutTypes): boolean => layout === LayoutTypes.DESKTOP;
const isSmLayout = (layout: LayoutTypes): boolean => layout === LayoutTypes.SM;
const isMobileLayout = (layout: LayoutTypes): boolean => isSmLayout(layout) || layout === LayoutTypes.MOBILE;
const isTabletLayout = (layout: LayoutTypes): boolean => layout === LayoutTypes.TABLET;

export default {
    isDesktopLayout,
    isMobileLayout,
    isSmLayout,
    isTabletLayout,
};
